// extracted by mini-css-extract-plugin
export var deleteModal = "_pv-0";